// extracted by mini-css-extract-plugin
module.exports = {"spanCol":"definition-list_spanCol__s7Vw_","wrapAnywhere":"definition-list_wrapAnywhere__5xSgw"};